import { ElMessage } from 'element-plus';

const showTime = 5000;

export function message(msg: string): void {
    ElMessage({
        message: msg,
        duration: showTime,
    });
}

export function messageSuccess(msg: string): void {
    ElMessage({
        message: msg,
        type: 'success',
        duration: showTime,
    });
}

export function messageWarning(msg: string): void {
    ElMessage({
        message: msg,
        type: 'warning',
        duration: showTime,
    });
}

export function messageError(msg: string): void {
    ElMessage({
        message: msg,
        type: "error",
        duration: showTime,
    });
}